import { VidstackPlayer, VidstackPlayerLayout } from 'https://cdn.vidstack.io/player@1.11.30';

class BulletPointWithVideo extends HTMLElement {
    constructor() {
        super();
        this.playerInitialized = false;
        this.loadStyles();
    }

    loadStyles() {
        const styleIds = ['vidstack-theme', 'vidstack-video'];
        const hrefs = [
            'https://cdn.vidstack.io/player/theme.css',
            'https://cdn.vidstack.io/player/video.css'
        ];

        styleIds.forEach((id, index) => {
            if (!document.getElementById(id)) {
                const link = document.createElement('link');
                link.id = id;
                link.rel = 'stylesheet';
                link.href = hrefs[index];
                document.head.appendChild(link);
            }
        });
    }

    connectedCallback() {
        if (!this.playerInitialized) {
            this.initializePlayer();
            this.playerInitialized = true;
        }
    }

    async initializePlayer() {
        const videoTarget = this.querySelector('.bullet-point-with-video__video-target-pc');
        const videoTargetMb = this.querySelector('.bullet-point-with-video__video-target-mb');

        if (videoTarget) {
            const src = videoTarget.dataset.src;
            if (src) {
                await VidstackPlayer.create({
                    target: videoTarget,
                    title: 'Video Player',
                    muted: true,
                    src: src,
                    loop: true,
                    load: 'visible',
                    volume: 0,
                    playsinline: true,
                    autoplay: true,
                    controls: true,
                    layout: new VidstackPlayerLayout({
                        thumbnails: 'https://files.vidstack.io/sprite-fight/thumbnails.vtt',
                    }),
                });
            }
        }

        if (videoTargetMb) {
            const srcMb = videoTargetMb.dataset.src;
            if (srcMb) {
                await VidstackPlayer.create({
                    target: videoTargetMb,
                    title: 'Video Player Mobile',
                    muted: true,
                    playsinline: true,
                    loop: true,
                    load: 'visible',
                    volume: 0,
                    src: srcMb,
                    autoplay: true,
                    controls: true,
                    layout: new VidstackPlayerLayout({
                        thumbnails: 'https://files.vidstack.io/sprite-fight/thumbnails.vtt',
                    }),
                });
            }
        }
    }
}

customElements.define('bullet-point-with-video', BulletPointWithVideo);
